<div class="tab-content" [class.loading]="loading">
  @if (loading) {
    <svg lucideLoaderCircle class="tab-loading-spinner lucide-spin"></svg>
  }
  @if (!loading) {
    <p class="double-margin-bottom">
      The tags defined here will be applied to resources {{ uiService.productName }} creates that are not replicated
      from the primary environment. Use these settings to satisfy Service Control Policies that require specific tags.
    </p>
    <form [formGroup]="tagSettingsFormModel" (ngSubmit)="updateResourceTags()" class="margin-top">
      <account-tags-form-control formControlName="resourceTags"></account-tags-form-control>
      <div class="flex-row-end margin-top">
        <button
          busy-button
          [busy]="submitting"
          [done]="doneSubmitting"
          class="arpio-button"
          type="submit"
          [disabled]="updateButtonDisabled"
        >
          Save
        </button>
      </div>
    </form>
  }
</div>
